





















import { Component, Prop, Vue } from "vue-property-decorator";
// import SlVueTree from "sl-vue-tree-sub-controller";
// import "sl-vue-tree-sub-controller/dist/sl-vue-tree-minimal.css";

import * as def from "@/definitions";

import { Design } from "@/model/document2/page/surface/design/design";
import { Layer } from "@/model/document2/page/surface/design/layer/layer";
import { GroupLayer } from "@/model/document2/page/surface/design/layer/groupLayer";

import { NameHelper } from "@/helper/nameHelper";
import { DebugHelper } from "@/helper/debugHelper";

import ToFront from "../resources/toFront.vue";
import Forward from "../resources/forward.vue";
import Backward from "../resources/backward.vue";
import ToBack from "../resources/toBack.vue";
import Group from "../resources/group.vue";
import Ungroup from "../resources/ungroup.vue";

import DraggableTree from "./draggableTree/draggableTree.vue"


import { UserAgentHelper } from "@/helper/userAgentHelper"
@Component({
  components: {
    ToFront,
    Forward,
    Backward,
    ToBack,
    Group,
    Ungroup,
    // SlVueTree,
    DraggableTree
  }
})
export default class ObjectList extends Vue {

  @Prop()
  private design!: Design;
  @Prop()
  private renameId!: number;
  @Prop()
  private opened!: boolean;

  private isGrabbing = false
  draggingPosition = {
    left : 0,
    top : 0
  }

  onGrabNode(event : MouseEvent){
    this.isGrabbing = true;
    this.draggingPosition = {
      left : event.clientX,
      top : event.clientY
    }
  }

  dragNode(event){
    this.draggingPosition = {
      left : event.clientX,
      top : event.clientY
    }
  }

  get allLayers(){
    return this.design.getAllLayers(true)
  }

  private onDoCommand(command: string, paramater: any) {
    this.$emit("doCommand", command, paramater);
  }

  private get nodes() {
    var nodes = new Array();
    // 全レイヤーをgroupLayer込みで取得
    if (this.design.layer instanceof GroupLayer) {
      var groupLayer = this.design.layer as GroupLayer;
      for (var i = groupLayer.getLayerCount() - 1; i >= 0; --i) {
        var child = groupLayer.getLayer(i);
        nodes.push(this.getNodeFromLayer(child));
      }
    } else {
      nodes.push(this.design.layer);
    }
    return nodes;
  }

  private set nodes(nodes) {
    // None
  }

  private getNodeFromLayer(layer: Layer) {
    var children = new Array();
    var isExpanded = false;
    if (layer instanceof GroupLayer) {
      var groupLayer = layer as GroupLayer;
      isExpanded = groupLayer.isExpanded;
      // 新しいオブジェクトが上に来るように逆に拾う
      for (var i = groupLayer.getLayerCount() - 1; i >= 0; --i) {
        var child = groupLayer.getLayer(i);
        children.push(this.getNodeFromLayer(child));
      }
    }

    // カレントレイヤーなら選択
    var isSelected = this.design.currentLayer == layer;
    if (!isSelected) {
      // 選択レイヤーなら選択
      for (var selectLayer of this.design.selectLayers) {
        if (selectLayer == layer) {
          isSelected = true;
          break;
        }
      }
    }

    return {
      title: layer.name,
      isLeaf: layer.layerType != "group",
      children: children,
      isExpanded: isExpanded,
      isSelected: isSelected,
      isDraggable: true,
      isSelectable: true,
      data: {
        id: layer.id,
        layerType: layer.layerType,
        isLocked: layer.isLocked
      }
    };
  }

  // ドラッグ
  // draggingNodes: ドラッグされたアイテム群
  // position: node, placement("after", "before", "inside")
  private onDropObjectTree(draggingNodes, position, event) {

    DebugHelper.trace(position)

    var toLayer = this.design.getLayerFromId(position.node.data.id);
    if (toLayer == null) {
      return;
    }
    var layers = new Array();
    for (var i = draggingNodes.length - 1; i >= 0; --i) {
      var draggingNode = draggingNodes[i];
      var layer = this.design.getLayerFromId(draggingNode.data.id);
      if (layer != null) {
        layers.push(layer);
      }
    }
    this.onDoCommand("moveLayerPosition", {
      layers: layers,
      toLayer: toLayer,
      placement: position.placement
    });
  }

  // 選択
  // selectedNodes: 選択されたアイテム群
  private onSelectObjectTree(selectedNodes, event) {
    if (selectedNodes.length == 0) {
      // 選択レイヤーを全部取り消す
      this.onDoCommand("changeSelectLayers", { layers: new Array() });
      // カレントレイヤーを外す
      this.onDoCommand("changeCurrentLayer", { layer: null });
    } else if (selectedNodes.length == 1) {
      var layer = this.design.getLayerFromId(selectedNodes[0].data.id);
      if (layer != null) {
        // 選択レイヤーを指定のレイヤーに変更
        this.onDoCommand("changeSelectLayers", { layers: [layer] });
        // カレントレイヤーを指定のレイヤーに変更
        this.onDoCommand("changeCurrentLayer", { layer: layer });
      }
    } else {
      var selectLayers = new Array();
      var isCurrentLayerSelected = false;
      for (var node of selectedNodes) {
        var layer = this.design.getLayerFromId(node.data.id);
        if (layer != null) {
          if (layer == this.design.currentLayer) {
            isCurrentLayerSelected = true;
          }
          selectLayers.push(layer);
        }
      }
      // 選択レイヤーの一斉変更
      this.onDoCommand("changeSelectLayers", { layers: selectLayers });
      if (!isCurrentLayerSelected) {
        // 選択レイヤーの先頭にカレントを変更
        if (selectLayers.length > 0) {
          this.onDoCommand("changeCurrentLayer", { layer: selectLayers[0] });
        }
      }
    }
  }

  // トグル *レイヤーの開閉
  // toggledNode: 開閉したアイテム
  private onToggleObjectTree(toggledNode, event) {
    var layer = this.design.getLayerFromId(toggledNode.data.id);
    if (layer != null && layer instanceof GroupLayer) {
      var isExpanded = layer.isExpanded;
      this.onDoCommand("changeLayerProperty", {
        layer: layer,
        propertyName: "isExpanded",
        value: !isExpanded,
        isFinish: true,
        isOnce: true
      });
    }
  }

  // レイヤーのロック
  private onLockObjectTree(node) {
    var layer = this.design.getLayerFromId(node.data.id);
    if (layer != null) {
      var isLocked = layer.isLocked;
      this.onDoCommand("changeLayerProperty", {
        layer: layer,
        propertyName: "isLocked",
        value: !isLocked,
        isFinish: true,
        isOnce: true
      });
    }
  }

  private onEditObjectTree(node) {
    this.$emit("editLayerName")
  }

  // レイヤーのリネーム
  private onRenameObjectTree(node, name) {
    var layer = this.design.getLayerFromId(node.data.id);
    if (layer != null) {
      if (name != layer.name) {
        this.onDoCommand("changeLayerProperty", {
          layer: layer,
          propertyName: "name",
          value: name,
          isFinish: true,
          isOnce: true
        });
      }
    }
    this.$emit("decideLayerName")
  }

  // コンテキストメニュー
  private onContextObjectTree(node, event) {
    // デフォルトのメニューを出さない
    event.preventDefault();

    if(this.design.currentLayer == null || this.design.selectLayers.length <= 1)
    {
      // 選択レイヤーが1つか、選択レイヤーがないときはクリックしたレイヤーを選択する
      var layer = this.design.getLayerFromId(node.data.id);
      if (layer != null) {
        // 選択レイヤーを指定のレイヤーに変更
        this.onDoCommand("changeSelectLayers", { layers: [layer] });
        // カレントレイヤーを指定のレイヤーに変更
        this.onDoCommand("changeCurrentLayer", { layer: layer });
      }
    }
    // コンテキストメニューを呼ぶ
    this.onDoCommand("showContextMenu", { event: event, type: "objectlist" });
  }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }
}
